import { FC } from "react";
import { EstablishHeader } from "views/components/atoms/establishes/header";
import { EstablishError } from "views/components/atoms/establishes/error";
import { SearchSelect } from "views/components/atoms/searchSelect";
import { EstablishSelect } from "views/components/atoms/establishes/select";

type InputChoicesProps = {
  title: string;
  options: string[];
  disabledOption?: string;
  selectedOption: string;
  setSelectedOption: (selectedOption: string) => void;
  isEnabled: boolean;
  errorText?: string;
  batchDangerWord?: string;
};

export const InputChoices: FC<InputChoicesProps> = (props) => {
  const {
    title,
    options,
    disabledOption,
    selectedOption,
    setSelectedOption,
    isEnabled,
    errorText,
    batchDangerWord,
  } = props;
  return (
    <div className="inputWrapper">
      <EstablishHeader headerTitle={title} batchDangerWord={batchDangerWord} />
      <EstablishSelect
        disabledOption={disabledOption}
        options={options}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
      />
      <EstablishError isEnabled={isEnabled} errorText={errorText} />
    </div>
  );
};
